import { render, staticRenderFns } from "./FacturePreformaList.vue?vue&type=template&id=21388d11&scoped=true&"
import script from "./FacturePreformaList.js?vue&type=script&lang=js&"
export * from "./FacturePreformaList.js?vue&type=script&lang=js&"
import style0 from "./FacturePreformaList.vue?vue&type=style&index=0&id=21388d11&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21388d11",
  null
  
)

export default component.exports